module.exports = __webpack_public_path__ + "static/media/Technology Club - Full v2.15aa92a6.png";